import { parseFaqAccordion } from 'components/FaqV2/components/FaqAccordion/FaqAccordion.parser';

import { parseProductDescription } from '../components/ProductDescription/ProductDescription.parser';
import parseProductPromotion from '../components/ProductPromotion/ProductPromotion.parser';
import { findContentfulComponentByName } from '../utils';
import { parseImageCarousel } from './components/ImageCarousel';
import { HeroWithProductProps } from './HeroWithProduct';

export function parseHeroWithProduct(
  section: Queries.ContentfulSection001,
): HeroWithProductProps {
  const subsections = section?.subsections as Queries.ContentfulSection001[];

  // Find the ProductDescription subsection
  const productDescriptionSection = findContentfulComponentByName(
    'ProductDescription',
    subsections,
  );

  // Find productPromotion subsection
  const productPromotionSection = findContentfulComponentByName(
    'ProductPromotion',
    subsections,
  );

  // Find productFaq subsection
  const productFaq = findContentfulComponentByName('ProductFaq', subsections);
  // Get the ImageCarousel subsection data
  const imageCarouselSection = findContentfulComponentByName(
    'ImageCarousel',
    subsections,
  );

  return {
    productDescription: parseProductDescription(productDescriptionSection),
    imageCarousel: parseImageCarousel(imageCarouselSection),
    productPromotion: parseProductPromotion(productPromotionSection),
    productFAQ: parseFaqAccordion(
      productFaq?.subsections as Queries.ContentfulSection001[],
    ),
    hasFakeProductDescription: subsections.some(
      (section) => section.componentName === 'FakeProductDescription',
    ),
  };
}
